export const discardChangesOnCancel = (intl, userAdministrationModal, modal) => {
  if (userAdministrationModal.hasUnsavedChanges) {
    modal.openModal({
      modalType: 'ConfirmationModal',
      modalProps: {
        type: 'error',
        title: intl.formatMessage({
          id: 'unsavedChanges',
        }),
        content: intl.formatMessage({
          id: 'unsavedChangesDescription',
        }),
        confirmLabel: intl.formatMessage({
          id: 'discard',
        }),
        cancelLabel: intl.formatMessage({
          id: 'stay',
        }),
        onConfirm: () => {
          modal.closeModal();
          userAdministrationModal.setHasUnsavedChanges(false);
          userAdministrationModal.setSelectedUser(null);
          userAdministrationModal.setService(null);
          userAdministrationModal.setIsAddingUser(false);
        },
      },
    });
  } else {
    userAdministrationModal.setIsAddingUser(false);
    userAdministrationModal.setSelectedUser(null);
    userAdministrationModal.setService(null);
  }
};
